import React from 'react';
import { OperationComponent } from './Operation';
import { Parameters as ParametersComponent } from './Parameters';
import { Badge, BadgeType, Markdown, Toggle } from '../../components';
import { bemClasses, removeSpecialChars } from '../../helpers';
import { MESSAGE_TEXT, ITEM_LABELS, CONTAINER_LABELS } from '../../constants';
import { isRawMessage, PayloadType } from '../../types';
export var ChannelComponent = function (_a) {
    var _b, _c;
    var name = _a.name, channel = _a.channel, _d = _a.toggleExpand, toggleExpand = _d === void 0 ? false : _d;
    var className = ITEM_LABELS.CHANNEL;
    var identifier = bemClasses.identifier([CONTAINER_LABELS.CHANNELS, name]);
    var dataIdentifier = bemClasses.identifier([
        CONTAINER_LABELS.CHANNELS,
        removeSpecialChars(name),
    ]);
    var message = (channel.publish && channel.publish.message) ||
        (channel.subscribe && channel.subscribe.message);
    var oneOfPublish = channel.publish &&
        channel.publish.message &&
        !isRawMessage(channel.publish.message);
    var oneOfSubscribe = channel.subscribe &&
        channel.subscribe.message &&
        !isRawMessage(channel.subscribe.message);
    var oneOfExists = Boolean(oneOfPublish || oneOfSubscribe);
    var header = (React.createElement("h3", null,
        React.createElement("ul", { className: bemClasses.element(className + "-header-badges") },
            channel.deprecated && (React.createElement("li", { className: bemClasses.element(className + "-header-badges-deprecated-badge") },
                React.createElement(Badge, { type: BadgeType.DEPRECATED }))),
            channel.publish && (React.createElement("li", { className: bemClasses.element(className + "-header-publish-badge") },
                React.createElement(Badge, { type: BadgeType.PUBLISH }))),
            channel.subscribe && (React.createElement("li", { className: bemClasses.element(className + "-header-subscribe-badge") },
                React.createElement(Badge, { type: BadgeType.SUBSCRIBE })))),
        React.createElement("span", { className: bemClasses.element(className + "-header-title") }, name)));
    var content = (React.createElement(React.Fragment, null,
        channel.description && (React.createElement("div", { className: bemClasses.element(className + "-description") },
            React.createElement(Markdown, null, channel.description))),
        React.createElement(ParametersComponent, { parameters: channel.parameters, identifier: bemClasses.identifier([
                { id: identifier, toKebabCase: false },
                'parameters',
            ]), dataIdentifier: bemClasses.identifier([
                { id: dataIdentifier, toKebabCase: false },
                'parameters',
            ]) }),
        React.createElement("div", { className: bemClasses.element(className + "-operations") },
            oneOfExists ? null : (React.createElement("header", { className: bemClasses.element(className + "-operations-header") },
                React.createElement("h4", null,
                    React.createElement("span", null, ((_b = message) === null || _b === void 0 ? void 0 : _b.title) || ((_c = message) === null || _c === void 0 ? void 0 : _c.name) ||
                        MESSAGE_TEXT)))),
            React.createElement("ul", { className: bemClasses.element(className + "-operations-list") },
                channel.subscribe && (React.createElement("li", { className: bemClasses.element(className + "-operations-subscribe") },
                    React.createElement(OperationComponent, { payloadType: PayloadType.SUBSCRIBE, operation: channel.subscribe, oneOf: oneOfSubscribe, otherOneOf: oneOfPublish, isPublish: !!channel.publish, isSubscribe: !!channel.subscribe }))),
                channel.publish && (React.createElement("li", { className: bemClasses.element(className + "-operations-publish") },
                    React.createElement(OperationComponent, { payloadType: PayloadType.PUBLISH, operation: channel.publish, otherOneOf: oneOfSubscribe, oneOf: oneOfPublish, isPublish: !!channel.publish, isSubscribe: !!channel.subscribe })))))));
    var body = (channel.subscribe || channel.publish) && content;
    return (React.createElement("section", { className: bemClasses.element(className), id: identifier, "data-asyncapi-id": dataIdentifier },
        React.createElement(Toggle, { header: header, className: className, expanded: toggleExpand, label: ITEM_LABELS.CHANNEL, itemName: name, toggleInState: true }, body)));
};
//# sourceMappingURL=Channel.js.map